declare let JSEncrypt: any;
import { Injectable } from "@angular/core";
import { UserService } from './user.service';

@Injectable()
export class CryptographyService {
  encryptor: any;
  private _uuid: string;

  constructor(private _userService: UserService) {
    this.encryptor = new JSEncrypt();
  }

  regeneratePublicKey(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this._userService
        .getPublicKey()
        .subscribe(
          response => {
            this._uuid = response.data.uuid;
            this.encryptor.setPublicKey(response.data.public_key);
            resolve();
          },
          error => {
            console.error('ERROR', error);
            reject(error);
          }
        );
    });
  }

  getUuid(): string {
    return this._uuid;
  }

  encrypt(text: string): string {
    return this.encryptor.encrypt(text);
  }

  async generatePKCE() {
    const codeVerifier = this.generateRandomString();

    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const sha256 = await crypto.subtle.digest('SHA-256', data);

    let str = '';
    const bytes = new Uint8Array(sha256);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }

    const codeChallenge = btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return { codeVerifier: codeVerifier, codeChallenge: codeChallenge };
  }

  dec2hex(dec: any) {
    let str = '0' + dec.toString(16);
    return str.substring(str.length - 2);
  }

  generateRandomString() {
    const array = new Uint32Array(56 / 2);
    crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join('');
  }
}
